import { Controller } from "@hotwired/stimulus"

// Chat UX: Enter-to-send, stick-to-bottom scroll, and Pensando → Escribiendo phases.
export default class extends Controller {
  static targets = ["messages", "status", "phaseLabel"]

  static values = {
    thinking: String,
    writing: String,
    online: String,
    delayMs: { type: Number, default: 2000 }
  }

  connect () {
    this.forceScrollToBottom()
    this.observeMessages()
  }

  disconnect () {
    this.clearPhaseTimer()
    if (this.messagesObserver) {
      this.messagesObserver.disconnect()
      this.messagesObserver = null
    }
  }

  submitOnEnter (event) {
    if (event.key !== "Enter" || event.shiftKey) return

    event.preventDefault()
    event.target.closest("form")?.requestSubmit()
  }

  phaseLabelTargetConnected () {
    this.startThinkingPhase()
    this.scrollToBottomIfSticky()
  }

  phaseLabelTargetDisconnected () {
    this.clearPhaseTimer()
    if (!this.hasPhaseLabelTarget) {
      this.restoreOnlineStatus()
    }
  }

  observeMessages () {
    if (!this.hasMessagesTarget) return

    this.messagesObserver = new MutationObserver(() => this.scrollToBottomIfSticky())
    this.messagesObserver.observe(this.messagesTarget, { childList: true })
  }

  forceScrollToBottom () {
    if (!this.hasMessagesTarget) return

    this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
  }

  scrollToBottomIfSticky () {
    if (!this.hasMessagesTarget) return
    if (!this.isNearBottom()) return

    this.forceScrollToBottom()
  }

  isNearBottom () {
    const el = this.messagesTarget
    const distance = el.scrollHeight - el.scrollTop - el.clientHeight
    return distance < 80
  }

  startThinkingPhase () {
    this.applyPhase(this.thinkingValue)
    this.clearPhaseTimer()
    this.phaseTimer = setTimeout(() => {
      if (this.hasPhaseLabelTarget) {
        this.applyPhase(this.writingValue)
      }
    }, this.delayMsValue)
  }

  applyPhase (text) {
    if (!text) return

    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
    }
    this.phaseLabelTargets.forEach((el) => {
      el.textContent = text
    })
  }

  restoreOnlineStatus () {
    if (this.hasStatusTarget && this.onlineValue) {
      this.statusTarget.textContent = this.onlineValue
    }
  }

  clearPhaseTimer () {
    if (this.phaseTimer) {
      clearTimeout(this.phaseTimer)
      this.phaseTimer = null
    }
  }
}
